/* eslint-disable */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";

export function SidebarLinks(props) {
  const location = useLocation();
  const { routes } = props;

  // Array of subtle light gradient backgrounds for routes
  const routeGradients = [
    "linear-gradient(135deg, rgba(30, 64, 175, 0.08) 0%, rgba(59, 130, 246, 0.08) 100%)", // Subtle blue
    "linear-gradient(135deg, rgba(16, 185, 129, 0.08) 0%, rgba(52, 211, 153, 0.08) 100%)", // Subtle green
    "linear-gradient(135deg, rgba(245, 158, 11, 0.08) 0%, rgba(251, 191, 36, 0.08) 100%)", // Subtle amber
    "linear-gradient(135deg, rgba(239, 68, 68, 0.08) 0%, rgba(248, 113, 113, 0.08) 100%)", // Subtle red
    "linear-gradient(135deg, rgba(139, 92, 246, 0.08) 0%, rgba(167, 139, 250, 0.08) 100%)", // Subtle purple
    "linear-gradient(135deg, rgba(14, 165, 233, 0.08) 0%, rgba(56, 189, 248, 0.08) 100%)", // Subtle cyan
    "linear-gradient(135deg, rgba(244, 63, 94, 0.08) 0%, rgba(251, 113, 133, 0.08) 100%)", // Subtle pink
  ];

  // Dark mode gradients
  const routeGradientsDark = [
    "linear-gradient(135deg, rgba(30, 64, 175, 0.12) 0%, rgba(59, 130, 246, 0.12) 100%)",
    "linear-gradient(135deg, rgba(16, 185, 129, 0.12) 0%, rgba(52, 211, 153, 0.12) 100%)",
    "linear-gradient(135deg, rgba(245, 158, 11, 0.12) 0%, rgba(251, 191, 36, 0.12) 100%)",
    "linear-gradient(135deg, rgba(239, 68, 68, 0.12) 0%, rgba(248, 113, 113, 0.12) 100%)",
    "linear-gradient(135deg, rgba(139, 92, 246, 0.12) 0%, rgba(167, 139, 250, 0.12) 100%)",
    "linear-gradient(135deg, rgba(14, 165, 233, 0.12) 0%, rgba(56, 189, 248, 0.12) 100%)",
    "linear-gradient(135deg, rgba(244, 63, 94, 0.12) 0%, rgba(251, 113, 133, 0.12) 100%)",
  ];

  const activeBgColor = useColorModeValue("green.600", "green.500");
  const hoverBgColor = useColorModeValue("rgba(30, 64, 175, 0.12)", "rgba(59, 130, 246, 0.12)");
  const textColor = useColorModeValue("gray.800", "gray.400");
  const activeTextColor = useColorModeValue("white", "white");

  const isActiveRoute = (routePath) => {
    return location.pathname.includes(routePath.toLowerCase());
  };

  return (
    <>
      {routes.map((route, index) => {
        if (route.category) {
          return (
            <React.Fragment key={index}>
              <Text
                fontSize="xs"
                color={useColorModeValue("gray.500", "gray.400")}
                fontWeight="bold"
                textTransform="uppercase"
                letterSpacing="wide"
                ps="12px"
                pt="16px"
                pb="8px"
                mb="1"
              >
                {route.name}
              </Text>
            </React.Fragment>
          );
        } else if (route.layout === "/admin") {
          const isActive = isActiveRoute(route.path);
          const gradientIndex = index % routeGradients.length;
          const currentGradient = useColorModeValue(
            routeGradients[gradientIndex],
            routeGradientsDark[gradientIndex]
          );
          const Wrapper = route.onClick ? Box : NavLink;
          const wrapperProps = route.onClick
            ? {
              onClick: route.onClick,
              cursor: "pointer",
            }
            : {
              to: route.layout + route.path,
            };

          return (
            <Wrapper key={index} {...wrapperProps}>
              <Box
                px="3"
                py="2.5"
                mx="1"
                mb="1"
                borderRadius="lg"
                bg={isActive ? activeBgColor : currentGradient}
                color={isActive ? activeTextColor : textColor}
                transition="all 0.2s ease"
                _hover={{
                  bg: isActive ? activeBgColor : hoverBgColor,
                  transform: "translateX(2px)",
                }}
                position="relative"
                overflow="hidden"
              >
                <Flex align="center">
                  <Flex
                    w="8"
                    h="8"
                    borderRadius="md"
                    bg={isActive ? "rgba(255, 255, 255, 0.2)" : "rgba(255, 255, 255, 0.6)"}
                    align="center"
                    justify="center"
                    mr="3"
                    transition="all 0.2s ease"
                    border={isActive ? "none" : "1px solid"}
                    borderColor={useColorModeValue(
                      "rgba(0, 0, 0, 0.08)",
                      "rgba(255, 255, 255, 0.1)"
                    )}
                  >
                    <Box
                      color={isActive ? "white" : "black"}
                      transform={isActive ? "scale(1.1)" : "scale(1)"}
                      transition="all 0.2s ease"
                    >
                      {route.icon}
                    </Box>
                  </Flex>

                  <Text
                    fontSize="sm"
                    fontWeight={isActive ? "600" : "500"}
                    letterSpacing="0.2px"
                    flex="1"
                  >
                    {route.name}
                  </Text>
                </Flex>
              </Box>
            </Wrapper>
          );

        }
        return null;
      })}
    </>
  );
}

export default SidebarLinks;